import Vue from 'vue';
//import Vuex from 'vuex';
//Vue.use(Vuex); 

//Import Ajax handler
import axios from 'axios';

// Import socket.io
import io from 'socket.io-client';

// Load CCC stream utilities
import { CCC } from '@/assets/vendor/ccc/ccc-streamer-utilities.js';

var Cookies = require('browser-cookies');


export default {
	
	namespaced: true,

	state: {

		//store data for individual coin lookups
		coinSnapshot: {},
		coinList: {},
		coinArray: [],
		coinSubs: {},
		coinPrice: {},
		coinStream: {},
		coinHistoricalPrice: {},
		exchangeList: {},
		exchangesByCoin: {},
		myExchanges: {},
		myCurrency: null,
		streamSocket: null,
	},

	mutations: {
		
		initialize (state, valueObj) {
			
			// Load saved exchanges
			
			var savedExchanges = JSON.parse(Cookies.get('cc-myexchanges'));
			
			if ((savedExchanges) && (typeof savedExchanges == 'object') && (Object.keys(savedExchanges).length)) {
				state.myExchanges = savedExchanges;
			}
			
			// Force average price as favorite for everyone
			if (!state.myExchanges['CCCAGG']) {
				state.myExchanges['CCCAGG'] = true;
			}
			
			
			var savedCurrency = Cookies.get('cc-mycurrency');
			
			if ((savedCurrency) && (typeof savedCurrency == 'string')) {
				state.myCurrency = savedCurrency;
			} else {
				state.myCurrency = "USD";
			}
			
//			if (valueObj) {
//				//update coin info
//				state.exchangeList = valueObj;
//			}
		},

		updateExchangeList (state, valueObj) {
			if (valueObj) {
				//update coin info
				state.exchangeList = valueObj;
			}
		},
		
		updateMyCurrency (state, valueObj) {
			
			if ((valueObj) && (typeof valueObj == 'string')) {
				//update coin info
				state.myCurrency = valueObj;
				Cookies.set('cc-mycurrency', state.myCurrency, {expires: 500});
			}
		},
		
		/**
		 * Update entire value
		 */
		updateMyExchanges (state, valueObj) {
			if (valueObj) {
				//update coin info
				state.myExchanges = valueObj;
				Cookies.set('cc-myexchanges', JSON.stringify(state.myExchanges), {expires: 500});
			}
		},
		
		// add individual exchange to list
		addMyExchange(state, exchange) {
			Vue.set(state.myExchanges, exchange, true);
			Cookies.set('cc-myexchanges', JSON.stringify(state.myExchanges), {expires: 500});
		},
		
		// remove individual exchange from list
		removeMyExchange(state, exchange) {
			Vue.delete(state.myExchanges, exchange);
			Cookies.set('cc-myexchanges', JSON.stringify(state.myExchanges), {expires: 500});
		},
		
		updateExchangesByCoin (state, valueObj) {
			if (valueObj) {
				//update coin info
				state.exchangesByCoin = valueObj;
			}
		},
		
		updateCoin (state, valueObj) {
			if (valueObj) {
				//update coin prices
				if ((valueObj.coin) && (state.coinInfo[valueObj.coin])) {
					state.coinInfo[valueObj.coin] = valueObj;
				}
			}
		}, 

		updateCoinSnapshot (state, valueObj) {
			if (valueObj) {
				//update coin info
				if ((valueObj.coin) && (state.coinSnapshot)) {
					state.coinSnapshot[valueObj.coin] = valueObj;
				}
			}
		},
		
		updateCoinHistoricalPrice (state, valueObj) {
			if (valueObj) {
				//update coin info
				if ((state.coinHistoricalPrice) && (valueObj['coin']) && (valueObj['date']) && (valueObj['exchange']) && (valueObj['price'])) {
					
					if (!state.coinHistoricalPrice[valueObj['coin']]) {
						state.coinHistoricalPrice[valueObj['coin']] = {};
					}
					if (!state.coinHistoricalPrice[valueObj['coin']][valueObj['date']]) {
						state.coinHistoricalPrice[valueObj['coin']][valueObj['date']] = {};
					}
					if (!state.coinHistoricalPrice[valueObj['coin']][valueObj['date']][valueObj['exchange']]) {
						state.coinHistoricalPrice[valueObj['coin']][valueObj['date']][valueObj['exchange']] = 0;
					}
					
					// Store price
					state.coinHistoricalPrice[valueObj['coin']][valueObj['date']][valueObj['exchange']] = valueObj['price'];

				}
			}
		},
		
		updateCoinSubs (state, valueObj) {
			if (valueObj) {
				//update coin info
				if ((valueObj.coin) && (state.coinSubs)) {
					state.coinSubs[valueObj.coin] = valueObj;
				}
			}
		},
		
		updateCoinPrice (state, valueObj) {
			if (valueObj) {
				//update coin info
				if ((valueObj.coin) && (state.coinPrice)) {
					state.coinPrice[valueObj.coin] = valueObj;
				}
			}
		},
		
		updateStreamSocket (state, ioObj) {
			state.streamSocket = ioObj;
		},
		
		updateCoinStream (state, data) {
//			if (valueObj) {
//				//update coin info
//				if ((valueObj.coin) && (state.coinStream)) {
//					state.coinStream[valueObj.coin] = valueObj;
//				}
//			}
			
			if (!CCC) {
				console.log("Error: CCC library not found.");
				return null;
			}
			
			var from = data['FROMSYMBOL'];
			var to = data['TOSYMBOL'];
			var fsym = CCC.STATIC.CURRENCY.getSymbol(from);
			var tsym = CCC.STATIC.CURRENCY.getSymbol(to);
			var pair = from + "-" + to;
			var market = "none";
			var currentRecord = {};
			console.log("CryptoCompareSubscription.updateCoinStream", data);
			
			var now = new Date().getTime()/1000; // get epoch seconds

			for (var key in data) {
				currentRecord[key] = data[key];
			}
			
			// Keep previous price if this one is empty, exclude inactive exchanges (cryptsy) by lastupdate < 7 days
			if ((currentRecord['PRICE']) && (currentRecord['LASTUPDATE']) && ((now - currentRecord['LASTUPDATE']) <= 86400*7)) {
			//if ((currentRecord['PRICE']) && (currentRecord['MARKET']) && (currentRecord['MARKET'] != "Cryptsy")) {
				
				currentRecord['pair'] = pair; // save pair it record

				if (currentRecord['LASTTRADEID']) {
					currentRecord['LASTTRADEID'] = parseInt(currentRecord['LASTTRADEID']).toFixed(0);
				}
				currentRecord['CHANGE24HOUR'] = CCC.convertValueToDisplay(tsym, (currentRecord['PRICE'] - currentRecord['OPEN24HOUR']));
				currentRecord['CHANGE24HOURPCT'] = ((currentRecord['PRICE'] - currentRecord['OPEN24HOUR']) / currentRecord['OPEN24HOUR'] * 100).toFixed(2) + "%";
				if (currentRecord['MARKET']) {
					market = currentRecord['MARKET'];
				}
				//displayData(currentRecord, from, tsym, fsym);			
				if (!state.coinStream[pair]) {
	//				state.coinStream[pair] = {};
					Vue.set(state.coinStream, pair, {});
				}
				Vue.set(state.coinStream[pair], market, currentRecord);
			
			}
			
//			state.coinStream[pair] = currentRecord;
			
			
		}

	},

	getters: {
		
		myExchanges: (state) => {
			
			return state.myExchanges;
		},
		
		myCurrency: (state) => {
			
			return state.myCurrency;
		},
		
		exchangeList: (state) => {
			return state.exchangeList;
		},
		
		exchangesByCoin: (state) => {
			return state.exchangesByCoin;
		},

		coinList: (state) => {
			// load coinlist from static file to reduce expensive calls to cyrptocompare for relatively static data
			// https://min-api.cryptocompare.com/data/all/coinlist
			return require('@/assets/data/coinlist.json');

		},
		
		currencyList: (state) => {
			// load coinlist from static file to reduce expensive calls to cyrptocompare for relatively static data
			// https://min-api.cryptocompare.com/data/all/coinlist
			return require('@/assets/data/currencylist.json');

		},
		
		coinArray: (state) => {
			
			if (state.coinArray.length) {
				return state.coinArray;
			}
			var coinList = require('@/assets/data/coinlist.json');
			
		},
		
		coinStream: (state) => {
			
			if (state.coinStream) {
				
				return state.coinStream;
			}
			return null;
		},
		
		streamSocket: (state) => {
			return state.streamSocket;
		}
		
	},

	actions: {
		
//		saveMyExchanges(context, exchangeList) {
//			
//			var myExchanges, returnPromise;
//			
//			if (exchangeList) {
//				myExchanges = exchangeList;
//			} else {
//				myExchanges = context.state.myExchanges;
//			}
//			
//			var returnPromise = new Promise();
//						
//			// return existing object if already built
//			if (Object.keys(myExchanges).length) {
//				
//				// save cookies
//				Cookies.set('cc-myexchanges', JSON.stringify(myExchanges), {expires: 500});
//				
//				// resolve
//				returnPromise.resolve(myExchanges);
//				
//			} else {
//			
//				returnPromise.reject("saveMyExchanges: Save cancelled, exchangeList is empty.");
//			
//			}
//			
//			return returnPromise;
//			
//		},
		
		getExchangeList(context) {
			
			var exchangeList, requestUrl;
			
			requestUrl = "https://min-api.cryptocompare.com/data/all/exchanges";
			
			
			exchangeList = context.state.exchangeList;
			
			// Check if a known exchange is there
			if (Object.keys(exchangeList).length) {
				
				// returns a promise that is instantly resolved

				return new Promise((resolve, reject) => {
					//console.log('Initial');

					resolve(exchangeList);
				});
				
			} else {
		
	
				return new Promise((resolve, reject) => {
					//https://min-api.cryptocompare.com/
					axios.get(requestUrl).then((response) => {
	
						if (response.data) {
							context.commit('updateExchangeList', response.data); // update state
						} else {
							reject("Error retreiving exchange list");
						}
	
	
						resolve(response.data); // return results
						
					}).catch(error => { console.log("Error retreiving exchange data from site:" + requestUrl, error); reject(error) });
				});
			}
		},
		
		getExchangesByCoin(context) {
			
			var exchangesByCoin = context.state.exchangesByCoin;
			
			// return existing object if already built
			if (Object.keys(exchangesByCoin).length) {
				
				// returns a promise that is instantly resolved

				return new Promise((resolve, reject) => {
					//console.log('Initial');

					resolve(exchangesByCoin);
				});
				
			} else {
			
				// build new object from exchange list
				return context.dispatch('getExchangeList').then((results) => { 
					
					/*
					 * Flip the exchanges list so we can find all the exchanges for each coin
					 * coin.exchange.currencyList
					 */
					
					for (var exchange in results) {
						for (var coin in results[exchange]) {
							if (!exchangesByCoin[coin]) {
								exchangesByCoin[coin] = {};
							}
							if (!exchangesByCoin[coin][exchange]) {
								// value is now all the coins that can trade for the coin on the exchange
								exchangesByCoin[coin][exchange] = results[exchange][coin];
							}
						}
					}
					
					context.commit('updateExchangesByCoin', exchangesByCoin); // update state
					
				}).catch(error => {console.log("Caught Error in getExchangesByCoin", error); throw error; });
			
			}			
			
		},
		
		getCoinHistoricalPrice (context, input) {
			
			var currency, coin, date, exchange;
			
			if ((!input) || (typeof input !== 'object')) {
				return Promise.reject("Invalid input to CryptoCompare.getCoinHistoricalPrice.");
			}
			
			if (!input.currency) {
				// Default to the user preferred currency, which also default to USD
				input.currency = context.state.myCurrency;
			}
			
			if (!input.coin) {
				return Promise.reject("Parameter 'coin' is required.");
			}
			
			if (!input.date) {
				return Promise.reject("Parameter 'date' is required.");
			}
			
			if (typeof input.date !== 'number') {
				return Promise.reject("Parameter 'date' must be an epoch date integer.");
			}
			
			if (!input.exchange) {
				// Default to aggregate price
				input.exchange = 'CCCAGG';
			}
			
			if ((context.state.coinHistoricalPrice[input.coin]) && (context.state.coinHistoricalPrice[input.coin][input.date]) && (context.state.coinHistoricalPrice[input.coin][input.date][input.exchange])) {
				
				// returns a promise that is instantly resolved

				return new Promise((resolve, reject) => {
					//console.log('Initial');

					resolve(context.state.coinHistoricalPrice[input.coin][input.date][input.exchange]);
				});
			
			} else {
				
				var requestUrl = "https://min-api.cryptocompare.com/data/dayAvg";
				var priceObj = {};
				var price;
				
				return new Promise((resolve, reject) => {
					//https://min-api.cryptocompare.com/
					axios.get(requestUrl, {
					    params: {
					    	'fsym': input.coin,
					    	'tsym': input.currency,
					    	'toTs': input.date,
					    	'e': input.exchange
					      }
					    }).then((response) => {
					    	
					    	if ((response.data) && (response.data[input.currency])) {
					    		price = response.data[input.currency];
					    	}
					    	
					    	priceObj = {
					    		'coin': input.coin,
					    		'date': input.date,
					    		'exchange': input.exchange,
					    		'price': price,
					    		'response': response,
					    	}
	
						if (response.data) {
							
							// Look for error message in response
							if ((response.data.Response) && (response.data.Response.match(/error/i))) {
								
								if (response.data.Message) {
									reject("Error retreiving historical price: " + response.data.Message);
								} else {
									reject("Error retreiving historical price: " + response.data.Response);
								}								
							}
							
							// Successful response
							context.commit('updateCoinHistoricalPrice', priceObj); // update state
						} else {
							reject("Error retreiving historical price");
						}
	
	
						resolve(price); // return results
						
					}).catch(error => { console.log("Error retreiving historical price data from site:" + requestUrl, error); reject(error) });
				});
				
			}
			return null;
		},
		
		getCoinSnapshot (context, coin) {
			if (context.state.coinSnapshot[coin]) {

				var lastUpdate = null;
				var age = 0;
				var now = new Date();
				if (context.state.coinSnapshot[coin]) {
					if (context.state.coinSnapshot[coin].lastUpdate) {
						lastUpdate = new Date(scontext.tate.coinSnapshot[coin].lastUpdate);
						age = now - lastUpdate;
					}
					// refresh if more than 5 minutes old, it should not get that old if auto refreshing (see refreshCoinInfo)
					if ((!context.state.coinSnapshot[coin].lastUpdate) || (age > 300000))  {
						// update the coin info then return it
						return context.dispatch('refreshCoinSnapshot', coin).then(() => { return context.state.coinSnapshot[coin] });
					}
				}
				// returns a promise that is instantly resolved

				var returnPromise = new Promise((resolve, reject) => {
					//console.log('Initial');

					resolve();
				}).then(() => { return context.state.coinSnapshot[coin] });

				return returnPromise;
			} else {
				// returns a promise
				return context.dispatch('refreshCoinSnapshot', coin).then(() => { return context.state.coinSnapshot[coin] });
			}
			return null;
		},


		refreshCoinSnapshot(context, coin) {
			if (coin) {

				var coinList, coinId;

				coinList = context.getters.coinList;

				// get ccc coin id
				if ((coinList) && (coinList.Data) && (coinList.Data[coin]) && (coinList.Data[coin]['Id'])) {
					coinId = coinList.Data[coin]['Id'];
				} else {
					console.log("Error: could not determine Id for coin: " + coin);
					return null;
				}

				if (!coinId) {
					console.log("Error: coinId is undefined for coin: " + coin);
					return null;
				}

				return new Promise((resolve, reject) => {
					//https://api-public.sandbox.gdax.com/products/
					//axios.get('https://www.cryptocompare.com/api/data/coinsnapshotfullbyid/?id=' + coinId).then((response) => {
					axios.get('/ccc/data/coinsnapshotfullbyid/?id=' + encodeURIComponent(coinId)).then((response) => {
						var result = response.data;

						// add items to coin info record
						result.coinId = coinId; 
						result.lastUpdate = Date.now();
						result.coin = response.data.Data.General.Symbol; 


						context.commit('updateCoinSnapshot', result); // update record


						resolve();
					}).catch(error => { console.log("Error retreiving snapshot data from site:" + requestUrl, error); reject(error) });
				});
			}
		},
		
		/**
		 * Gets a list of subscriptions (websocket streams) available for the coin
		 * API: https://min-api.cryptocompare.com/data/subs?fsym=POE
		 * @return promise
		 */
		getCoinSubs(context, coin) {
			if (context.state.coinSubs[coin]) {

				var lastUpdate = null;
				var age = 0;
				var now = new Date();
				if (context.state.coinSubs[coin]) {
					if (context.state.coinSubs[coin].lastUpdate) {
						lastUpdate = new Date(context.state.coinSubs[coin].lastUpdate);
						age = now - lastUpdate;
					}
					// refresh if more than 5 minutes old, it should not get that old if auto refreshing (see refreshCoinInfo)
					if ((!context.state.coinSubs[coin].lastUpdate) || (age > 300000))  {
						// update the coin info then return it
						//return context.dispatch('refreshCoinSubs', coin).then(() => { return context.state.coinSubs[coin] } ).catch(error => {console.log("Caught Error in getCoinSubs, bubble up", error) });
						return context.dispatch('refreshCoinSubs', coin).then(() => { return context.state.coinSubs[coin] } );
					}
				}
				
				// returns a promise that is instantly resolved
				var returnPromise = new Promise((resolve, reject) => {
					//console.log('Initial');

					resolve();
				}).then(() => { return context.state.coinSubs[coin] });

				return returnPromise;
				
			} else {
				
				// returns a promise
				return context.dispatch('refreshCoinSubs', coin).then(() => { return context.state.coinSubs[coin] }).catch(error => {console.log("Caught Error in getCoinSubs, bubble up2", error); throw error; });
				//return context.dispatch('refreshCoinSubs', coin).then(() => { return context.state.coinSubs[coin] });
			}
//			return null;
		},
		
		refreshCoinSubs(context, coin) {
			if (coin) {

//				var coinList, coinId;

				// validate coin?

				return new Promise((resolve, reject) => {
					//https://api-public.sandbox.gdax.com/products/
					//axios.get('https://www.cryptocompare.com/api/data/coinsnapshotfullbyid/?id=' + coinId).then((response) => {
					var requestUrl = 'https://min-api.cryptocompare.com/data/subs?fsym=' + encodeURIComponent(coin);
					axios.get(requestUrl).then((response) => {
						var result = {};

						// add items to coin info record
						result.lastUpdate = Date.now();
						result.coin = coin;
						result.data = {}; // some coins have no subs available
						
						if (response.data) {
						
							if (response.data.Response) {
								// error occurred or this coin has no subscriptions
								
							} else {
								// add response to storage object
								result.data = response.data;
							}
						
						}


						context.commit('updateCoinSubs', result); // update record


						resolve();
					},
//					(error) => {
//						console.log("Error retreiving data from site:" + requestUrl, error);						
//						
//					}
					
					)
					.catch(error => { console.log("Error retreiving subscription data from site:" + requestUrl, error); reject(error) });
				});
			} else {
				
				return new Promise((resolve, reject) => {
					
					// return promise and immediately reject

					reject("Error: invalid input, coin is empty");
				});
			}
		},
		
		/**
		 * Gets a list of subscriptions (websocket streams) available for the coin
		 * API: https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=JPY,EUR
		 * @return promise
		 */
		getCoinPrice(context, input) {
			// validate inputs
			if ((!input) || (typeof input !== 'object')) {
				return Promise.reject("Invalid input to CryptoCompare.getCoinPrice.");
			}
			
			if (!input.coin) {
				return Promise.reject("Parameter 'coin' is required.");
			}
			
			if (!input.quoteCoin) {
				return Promise.reject("Parameter 'quoteCoin' is required.");
			}
			
			var coin = input.coin;
			var quoteCoin = input.quoteCoin;
			
//			// If subscribed to a price stream, get current price
//			if (context.state.coinPrice[coin]) {

				var lastUpdate = null;
				var age = 0;
				var now = new Date();
				
				// If we have a current price return it immediately, otherwise refresh it
				if (context.state.coinPrice[coin]) {
					if (context.state.coinPrice[coin].lastUpdate) {
						lastUpdate = new Date(context.state.coinPrice[coin].lastUpdate);
						age = now - lastUpdate;
					}
					
					// If the price is fresh, return it immediately
					if ((context.state.coinPrice[coin].lastUpdate) && (age < 300000)) {
						
						// returns a promise that is instantly resolved
						return new Promise((resolve, reject) => {
							//console.log('Initial');

							resolve();
						}).then(() => { return context.state.coinPrice[coin] });
						
					}
					
//					// refresh if more than 5 minutes old, it should not get that old if auto refreshing (see refreshCoinInfo)
//					if ((!context.state.coinPrice[coin].lastUpdate) || (age > 300000))  {
//						// update the coin info then return it
//						return context.dispatch('refreshCoinPrice', input).then(() => { return context.state.coinPrice[coin] });
//					} else {
//						// Return current price
//						
//						// returns a promise that is instantly resolved
//						return new Promise((resolve, reject) => {
//							//console.log('Initial');
//
//							resolve();
//						}).then(() => { return context.state.coinPrice[coin] });
//						
//					}
				}
				
				// return promise to get fresh price
				return context.dispatch('refreshCoinPrice', input).then(() => { return context.state.coinPrice[coin] });
				
				

//				return returnPromise;
				
//			} else {
//				
//				// returns a promise
//				return context.dispatch('refreshCoinPrice', input).then(() => { return context.state.coinPrice[coin] });
//			}
//			return null;
		},
		
		refreshCoinPrice(context, input) {
			
			// validate inputs
			if ((!input) || (typeof input !== 'object')) {
				return Promise.reject("Invalid input to CryptoCompare.refreshCoinPrice.");
			}
			
			if (!input.coin) {
				return Promise.reject("Parameter 'coin' is required.");
			}
			
			if (!input.quoteCoin) {
				return Promise.reject("Parameter 'quoteCoin' is required.");
			}
			
			var coin = input.coin;
			var quoteCoin = input.quoteCoin;
			
			if (coin) {

//				var coinList, coinId;

				// validate coin?

				return new Promise((resolve) => {
					//API: https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=JPY,EUR
					//axios.get('https://www.cryptocompare.com/api/data/coinsnapshotfullbyid/?id=' + coinId).then((response) => {
					axios.get('https://min-api.cryptocompare.com/data/price?fsym=' + encodeURIComponent(coin) + "&tsyms=" + encodeURIComponent(quoteCoin)).then((response) => {
						var result = {};

						// add items to coin info record
						result.lastUpdate = Date.now();
						result.coin = coin;
						result.data = {}; // some coins have no subs available
						
						if (response.data) {
						
							if (response.data.Response) {
								// error occurred or this coin has no subscriptions
								
							} else {
								// add response to storage object
								result.data = response.data;
							}
						
						}


						context.commit('updateCoinPrice', result); // update record


						resolve();
					});
				});
			}
		},
		
		subscribe(context, subscriptions) {
			
			return new Promise((resolve, reject) => {
			
				if (subscriptions) {
					
					if (!CCC) {
						console.log("Error: CCC library not found.");
						reject("Error: CCC library not found.");
					}
					
					var socket;
					//var connection;
					var currentPrice = {};
					
					if (!context.state.streamSocket) {
						context.state.streamSocket = io('https://streamer.cryptocompare.com/');
						context.state.streamSocket.on("m", function(message) {
							var messageType = message.substring(0, message.indexOf("~"));
							var res = {};
							if ((messageType == CCC.STATIC.TYPE.CURRENT) || (messageType == CCC.STATIC.TYPE.CURRENTAGG)) {
								res = CCC.CURRENT.unpack(message);
								//return context.dispatch('dataUnpack', res).then(() => { return context.state.coinSubs[coin] });
								return context.commit('updateCoinStream', res); // update record
								
							}
						});
					}
					
					socket = context.state.streamSocket;
					
					socket.open();
					//Format: {SubscriptionId}~{ExchangeName}~{FromSymbol}~{ToSymbol}
					//Use SubscriptionId 0 for TRADE, 2 for CURRENT and 5 for CURRENTAGG
					//For aggregate quote updates use CCCAGG as market
					
					if (subscriptions.constructor !== Array) {
						console.log("Error: invalid parameter subscriptions to subscribe()");
						reject("Error: invalid parameter subscriptions to subscribe()");
					}
					
					socket.emit('SubAdd', { subs: subscriptions });
					resolve();
					
				
				} else {
					reject("No subscriptions submitted");
				}
			
			});
		},
		
		subscribeOLD(context, subscriptions) {
			
			if (subscriptions) {
				
				if (!CCC) {
					console.log("Error: CCC library not found.");
					return null;
				}
				
				var currentPrice = {};
				var socket = io.connect('https://streamer.cryptocompare.com/');
				//Format: {SubscriptionId}~{ExchangeName}~{FromSymbol}~{ToSymbol}
				//Use SubscriptionId 0 for TRADE, 2 for CURRENT and 5 for CURRENTAGG
				//For aggregate quote updates use CCCAGG as market
				
				if (subscriptions.constructor !== Array) {
					console.log("Error: invalid parameter subscriptions to subscribe()");
					return null;
				}
				
				socket.emit('SubAdd', { subs: subscriptions });
				socket.on("m", function(message) {
					var messageType = message.substring(0, message.indexOf("~"));
					var res = {};
					if ((messageType == CCC.STATIC.TYPE.CURRENT) || (messageType == CCC.STATIC.TYPE.CURRENTAGG)) {
						res = CCC.CURRENT.unpack(message);
						//return context.dispatch('dataUnpack', res).then(() => { return context.state.coinSubs[coin] });
						return context.commit('updateCoinStream', res); // update record
						
					}
				});
			
			}
		},
		
		unsubscribe(context, subscriptions) {
			
			return new Promise((resolve, reject) => {
				
				if (subscriptions) {
					
					if (!CCC) {
						console.log("Error: CCC library not found.");
						reject("Error: CCC library not found.");
					}
					
					var socket;
					//var connection;
					var currentPrice = {};
					
					if (!context.state.streamSocket) {
						// no connection exists
						resolve();
					}
					
					socket = context.state.streamSocket;
					
					socket.open();
					//Format: {SubscriptionId}~{ExchangeName}~{FromSymbol}~{ToSymbol}
					//Use SubscriptionId 0 for TRADE, 2 for CURRENT and 5 for CURRENTAGG
					//For aggregate quote updates use CCCAGG as market
					
					if (subscriptions.constructor !== Array) {
						console.log("Error: invalid parameter subscriptions to unsubscribe()");
						reject("Error: invalid parameter subscriptions to unsubscribe()");
					}
					
					socket.emit('SubRemove', { subs: subscriptions });
					resolve();					
				
				} else {
					reject("No subscriptions submitted");
				}
			});
			
			
		},
		
//		dataUnpack(data) {
//			
//			if (!CCC) {
//				console.log("Error: CCC library not found.");
//				return null;
//			}
//			
//			var from = data['FROMSYMBOL'];
//			var to = data['TOSYMBOL'];
//			var fsym = CCC.STATIC.CURRENCY.getSymbol(from);
//			var tsym = CCC.STATIC.CURRENCY.getSymbol(to);
//			var pair = from + to;
//			var currentPrice = {};
//			console.log("CryptoCompareSubscription.dataUnpack", data);
//
//			if (!currentPrice.hasOwnProperty(pair)) {
//				currentPrice[pair] = {};
//			}
//
//			for (var key in data) {
//				currentPrice[pair][key] = data[key];
//			}
//			currentPrice[pair][pair] = pair; // save pair it record
//
//			if (currentPrice[pair]['LASTTRADEID']) {
//				currentPrice[pair]['LASTTRADEID'] = parseInt(currentPrice[pair]['LASTTRADEID']).toFixed(0);
//			}
//			currentPrice[pair]['CHANGE24HOUR'] = CCC.convertValueToDisplay(tsym, (currentPrice[pair]['PRICE'] - currentPrice[pair]['OPEN24HOUR']));
//			currentPrice[pair]['CHANGE24HOURPCT'] = ((currentPrice[pair]['PRICE'] - currentPrice[pair]['OPEN24HOUR']) / currentPrice[pair]['OPEN24HOUR'] * 100).toFixed(2) + "%";;
//			//displayData(currentPrice[pair], from, tsym, fsym);
//			context.commit('updateCoinStream', currentPrice[pair]); // update record
//			
//		}

	}

};



// WEBPACK FOOTER //
// ./src/store/modules/CryptoCompare.js